module.exports = __webpack_public_path__ + "static/media/map_pin_signal.e7163d27.svg";